// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4abf87f1","482":"c1339d71","637":"6e9b36ea"}[chunkId] + ".chunk.js";
};